import seo from './seo/routes.json';

export const SITE_URL = seo.siteUrl;

const CALENDLY_URL = 'https://calendly.com/kultio';

// One event type, one label, one URL. The placement rides along as utm_content so a
// booking's origin shows up in Calendly's own record without a second event type.
export const bookingUrl = (placement: string) =>
  `${CALENDLY_URL}?utm_source=kult.io&utm_medium=site&utm_content=${encodeURIComponent(placement)}`;

export const CTA_LABEL = 'Book a free assessment';
// The AWS practice sells its own free assessment, with its own scope: where the spend
// goes, what is exposed, what we would change first. It is the one documented exception
// to the single-label rule, and it exists because booking the agent assessment off an
// infrastructure page books the wrong meeting.
export const CTA_LABEL_AWS = 'Book an AWS assessment';
export const CTA_SUBLINE =
  'Thirty minutes, no charge. You leave with an honest read on whether it is worth automating.';
export const CTA_SUBLINE_SHORT = 'Thirty minutes. No charge. No deck.';

export const CONTACT_EMAIL = 'info@kult.io';
